import { styled } from '@mui/material';

import { Typography } from '@app-velocity/ui';
import { useI18n } from '@app-velocity/i18n';

import { useMyReportsContext } from '../../context/useMyReportsContext';

const StyledCount = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
}));

export const TotalReportsCount = () => {
  const { t } = useI18n();
  const { figmaTotalElements, vibeTotalElements } = useMyReportsContext();

  return (
    <StyledCount>
      {t('users:reports.count', {
        count: figmaTotalElements + vibeTotalElements,
      })}
    </StyledCount>
  );
};
